export default __webpack_public_path__ + "static/media/logo.f625c475.png";